import { forwardRef, createElement } from 'react';

function IconStarSolid(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M8.895 8.726l-6.683.358-.105.012c-.608.114-.833.91-.328 1.319l5.197 4.217-1.725 6.467-.02.098c-.085.616.605 1.08 1.152.725L12 18.28l5.617 3.64.087.05c.56.27 1.214-.242 1.045-.872l-1.726-6.467 5.198-4.217.077-.072c.425-.45.14-1.225-.51-1.26l-6.684-.357L12.7 2.481a.75.75 0 00-1.4 0L8.895 8.726z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var StarSolid = /*#__PURE__*/forwardRef(IconStarSolid);

export default StarSolid;
//# sourceMappingURL=StarSolid.js.map
